import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import {
  AccountCircleOutlined,
  Search,
  ShoppingCart,
  Wallet,
} from "@mui/icons-material";

import Logo from "../assets/logo.jpeg";

const drawerWidth = 240;
const navItems = ["Drop", "Status", "Resources"];

function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant='h6' sx={{ my: 2 }} fontWeight={"bold"}>
        OpenSea
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component='nav' color='inherit'>
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ width: "7%", display: { xs: "none", sm: "block" } }}>
            <div>
              <img src={Logo} alt='OpenSea' width={"110px"} />
            </div>
          </Box>
          <Box
            sx={{
              width: "83%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Divider
              orientation='vertical'
              flexItem
              sx={{ mx: 3, display: { xs: "none", sm: "block" } }}
            />

            <Box sx={{ display: { xs: "none", sm: "flex" } }}>
              <Typography color='black' fontWeight={"bold"}>
                Drops
              </Typography>
              <Typography ml={2} color='black' fontWeight={"bold"}>
                Stats
              </Typography>
            </Box>

            {/* Search field here */}
            <Box
              component='form'
              noValidate
              autoComplete='off'
              ml={2}
              sx={{
                display: { sm: "flex", xs: "none" },
                alignItems: "center",
                justifyContent: "right",
              }}
            >
              <FormControl sx={{ width: { xl: "125ch", lg: "90ch" } }}>
                <OutlinedInput
                  placeholder='Search items, collections, and accounts'
                  sx={{ borderRadius: "10px", height: "45px" }}
                  fullWidth
                  startAdornment={
                    <InputAdornment position='start'>
                      <Search />
                    </InputAdornment>
                  }
                  endAdornment={
                    <Box
                      sx={{
                        px: "12px",
                        py: "4px",
                        borderRadius: "10px",
                        bgcolor: "#E5E8EB",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      /
                    </Box>
                  }
                />
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  ml: 1,
                  width: "fit-content",
                  border: (theme) => `1px solid ${theme.palette.divider}`,
                  borderRadius: 1,
                  bgcolor: "background.paper",
                  color: "text.secondary",
                  "& svg": {
                    m: 1.5,
                  },
                  "& hr": {
                    mx: 0.5,
                  },
                }}
              >
                <Wallet sx={{ color: "#353840" }} />
                <Typography
                  sx={{ color: "#353840" }}
                  fontWeight={"bold"}
                  mr={1}
                >
                  Connect wallet
                </Typography>
                <Divider orientation='vertical' flexItem />
                <AccountCircleOutlined sx={{ color: "#353840" }} />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: "5%",
              display: "flex",
              justifyContent: "right",
            }}
          >
            <Box
              sx={{
                border: "1px solid lightgray",
                height: "50px",
                width: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "10px",
                px: 3,
              }}
            >
              <ShoppingCart />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Box component='nav'>
        <Drawer
          container={container}
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box component='main' sx={{ p: 3 }}>
        <Toolbar />
      </Box>
    </Box>
  );
}

export default Header;
